import { render, staticRenderFns } from "./NewBill.vue?vue&type=template&id=8f78dd92&"
import script from "./NewBill.vue?vue&type=script&lang=js&"
export * from "./NewBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports